"use client";

import { useState } from "react";

// Démo "avant / après" (refonte) : la capture de leur site actuel face à la
// maquette de leur future page d'accueil, avec un curseur de comparaison.
// Proposée seulement quand les deux images existent (décision 2026-09-27).

export function BeforeAfter({
  beforeSrc,
  afterSrc,
  onInteract,
  onComplete,
  lang = "fr",
}: {
  beforeSrc: string;
  afterSrc: string;
  onInteract: () => void;
  onComplete: () => void;
  lang?: "fr" | "en";
}) {
  const en = lang === "en";
  const [pos, setPos] = useState(50);
  return (
    <div className="space-y-3">
      <div className="relative aspect-[16/10] w-full select-none overflow-hidden rounded-lg border border-line bg-paper-alt">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={afterSrc} alt={en ? "Your future home page" : "Votre future page d'accueil"} className="absolute inset-0 h-full w-full object-cover object-top" />
        <div className="absolute inset-0 overflow-hidden" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={beforeSrc} alt={en ? "Your current site" : "Votre site actuel"} className="h-full w-full object-cover object-top" />
        </div>
        <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-gold" style={{ left: `${pos}%` }} />
        <span className="absolute left-3 top-3 rounded-full bg-ink/70 px-2.5 py-1 text-xs text-paper">{en ? "Today" : "Aujourd'hui"}</span>
        <span className="absolute right-3 top-3 rounded-full bg-navy px-2.5 py-1 text-xs text-paper">{en ? "Tomorrow" : "Demain"}</span>
        <input
          type="range"
          min={0}
          max={100}
          value={pos}
          aria-label={en ? "Compare your current site and the mockup" : "Comparer votre site actuel et la maquette"}
          onChange={(e) => {
            const v = Number(e.target.value);
            setPos(v);
            onInteract();
            if (v < 15 || v > 85) onComplete();
          }}
          className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
        />
      </div>
      <p className="text-center text-xs text-ink/50">
        {en
          ? "Drag: your current site on the left, the mockup of your future home page on the right."
          : "Faites glisser : à gauche votre site actuel, à droite la maquette de votre future page d'accueil."}
      </p>
    </div>
  );
}
